// Auth.js
import React, { useEffect } from "react";
import { Box, Grid } from "@mui/material";

import "../App.css";
import Nav1 from "./navV1";
import Nav from "./nav";
import { useLocation } from "react-router-dom";
import { analytics } from "../helper/helper";
import BottomNavigation from "./Nav/bottomNavigation";
import SearchBar from "./Nav/searchBar";
import { useSelector } from "react-redux";
import { nonProtectedRoute } from "../helper/useAuthStatus";
import { isWeb } from "../utils/platform";

const CroboContainer = ({
  children,
  showSearchBar = false,
  hideNav = false,
}) => {
  const isAuthenticated = useSelector(
    (state) => state.userAuth.isAuthenticated
  );
  const location = useLocation();

  useEffect(() => {
    const pageName =
      location.pathname.replace(/\//g, "").toUpperCase() || "HOME";
    const normalizePathname = (pathname) => {
      // Define patterns for dynamic segments
      const patterns = [
        {
          pattern: /\/transaction\/complete\/\d+/,
          replacement: "/transaction/complete/:id",
        },
        {
          pattern: /\/transaction\/confirm\/\d+\/\d+/,
          replacement: "/transaction/confirm/:id/:amount",
        },
        {
          pattern: /\/transaction\/details\/\d+/,
          replacement: "/transaction/details/:transid",
        },
        {
          pattern: /\/transaction\/create\/\d+/,
          replacement: "/transaction/create/:id",
        },
        {
          pattern: /\/transaction\/recipient\/\d+/,
          replacement: "/transaction/recipient/:id",
        },
        // Add more patterns here as needed
      ];

      let normalizedPath = pathname;
      patterns.forEach(({ pattern, replacement }) => {
        if (pattern.test(pathname)) {
          normalizedPath = replacement;
        }
      });

      return normalizedPath;
    };
     const normalizedPath = normalizePathname(location.pathname);
    analytics.page(`REMIT ${normalizedPath}`, {
      page_name: pageName,
      path: normalizedPath,
      search: location.search,
      hash: location.hash,
    });
  }, [location]);

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        position: "relative",
        backgroundColor: "background.default",
      }}
    >
      {!hideNav ? (
        <>
          {nonProtectedRoute.includes(location.pathname) ? <Nav1 /> : <Nav />}
        </>
      ) : (
        <Box
          className={"homeContentContainer"}
          sx={{
            backgroundColor: "background.default",
            position: "sticky",
            height: `calc(env(safe-area-inset-top))`,
            width: "100%",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100000,
          }}
        ></Box>
      )}
      <Grid
        container
        direction="row"
        justifyContent="center"
        sx={{ height: "100%" }}
      >
        <Grid
          xs={12}
          sm={8}
          md={5}
          xl={4}
          item={true}
          height={"100%"}
          alignItems={"center"}
          display={"flex"}
          justifyContent={"center"}
          flexDirection={"column"}
        >
          <Box
            flexGrow={1}
            sx={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
              paddingBottom: isWeb() ? "66px" : "100px",
            }}
          >
            {children}
          </Box>
          {isAuthenticated && (
            <Box
              position={"fixed"}
              sx={{
                zIndex: 100000,
                bottom: 0,
                width: "100%",
                display: { xs: "block", md: "none" }, // Hide on medium and larger screens
              }}
            >
              <BottomNavigation />
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CroboContainer;
